module.exports = __webpack_public_path__ + "486fcc3c12ed38dff19744eae4724305.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximanova-semibold-webfont.ttf
// module id = 313
// module chunks = 0